export default __webpack_public_path__ + "static/media/FREE_NBACK_ICONA.14ea5156.svg";